(function () {
  const DRAG_THRESHOLD = 12;
  const SCROLL_THRESHOLD = 2;
  const MOBILE_MQ = window.matchMedia('(max-width: 749px)');

  function shouldEnableDrag(scrollWrap) {
    if (!MOBILE_MQ.matches) return false;
    return scrollWrap.scrollWidth > scrollWrap.clientWidth + 1;
  }

  function initCollectionLinksMenu(root) {
    const scrollWrap = root.querySelector('.clm-scroll-wrap');
    if (!scrollWrap || scrollWrap.dataset.clmScrollInit === 'true') return;
    if (window.Shopify && window.Shopify.designMode) return;

    scrollWrap.dataset.clmScrollInit = 'true';

    let isPointerDown = false;
    let didDrag = false;
    let startX = 0;
    let startScrollLeft = 0;

    const endPointer = () => {
      isPointerDown = false;
      scrollWrap.classList.remove('is-dragging');
    };

    scrollWrap.addEventListener(
      'pointerdown',
      (event) => {
        if (!shouldEnableDrag(scrollWrap)) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;

        isPointerDown = true;
        didDrag = false;
        startX = event.clientX;
        startScrollLeft = scrollWrap.scrollLeft;
      },
      { passive: true }
    );

    scrollWrap.addEventListener(
      'pointermove',
      (event) => {
        if (!isPointerDown || !shouldEnableDrag(scrollWrap)) return;

        const deltaX = event.clientX - startX;
        if (Math.abs(deltaX) < DRAG_THRESHOLD) return;

        scrollWrap.classList.add('is-dragging');
        scrollWrap.scrollLeft = startScrollLeft - deltaX;

        if (Math.abs(scrollWrap.scrollLeft - startScrollLeft) > SCROLL_THRESHOLD) {
          didDrag = true;
        }
      },
      { passive: true }
    );

    scrollWrap.addEventListener('pointerup', endPointer);
    scrollWrap.addEventListener('pointercancel', endPointer);
    scrollWrap.addEventListener('lostpointercapture', endPointer);

    scrollWrap.addEventListener(
      'click',
      (event) => {
        const link = event.target.closest('.clm-link');
        if (!link || !didDrag) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        didDrag = false;
      },
      true
    );
  }

  function initRotatingText(el) {
    if (el.dataset.clmRotateInit === 'true') return;
    if (window.Shopify && window.Shopify.designMode) return;

    const raw = el.dataset.clmRotateMessages || '';
    const extra = raw
      .split('|~|')
      .map((msg) => msg.trim())
      .filter(Boolean);
    if (!extra.length) return;

    el.dataset.clmRotateInit = 'true';

    const messages = [el.textContent.trim()].concat(extra.map((msg) => msg.toUpperCase()));
    const interval = parseInt(el.dataset.clmRotateInterval, 10) || 3000;
    let index = 0;

    setInterval(() => {
      index = (index + 1) % messages.length;
      el.classList.add('clm-text--fade');
      window.setTimeout(() => {
        el.textContent = messages[index];
        el.classList.remove('clm-text--fade');
      }, 200);
    }, interval);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.cs-collection-links-menu').forEach(initCollectionLinksMenu);
    (scope || document).querySelectorAll('[data-clm-rotate]').forEach(initRotatingText);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
